import {useMatch} from 'react-router';

import {PAGE_HOTELS, PAGE_OFFERS, ROUTES} from '@/consts';

export const useCurrentPage = () => {
  const hotelsPageMatch = useMatch(ROUTES.hotelsPage);

  if (hotelsPageMatch) {
    return PAGE_HOTELS;
  }

  return PAGE_OFFERS;
};
